import { IconProps } from '..';

export default function IconViewDay({
  width = 16,
  height = 16,
  color = '#BCB8C4'
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="calendar_view_day_24dp_FILL1_wght400_GRAD0_opsz24 (1)">
        <path
          id="Vector"
          d="M2 14V12.6667H14V14H2ZM2 11.3333V4.66667H14V11.3333H2ZM2 3.33333V2H14V3.33333H2Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
